import type { Seo } from '$lib/types'

export const load = async () => {
  return {
    seo: {
      title: 'Privacy Policy',
    } satisfies Seo,
  }
}
